import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';

import CONFIG from '../../CONFIG.js';

psl_ui.templates.add('popup',template);

class Popup{
	constructor(){
		const {el, rpoints} = psl_ui.templates.render('popup');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;
	}

	render(data){
		this.data=data;
		this._rpoints.header.innerHTML=data.header||"";
		this._rpoints.subheader.innerHTML=data.subheader||"";

		let img_number = 0;
		this._rpoints.content.innerHTML=data.content.map(item=>{
			if(item.type==="img"){
				return `<img src="${CONFIG.backend_base_url}files/${item.data}">`; // data-action="popups.show.viewer_from_regular" data-data="${img_number}"
			} else if(item.type==="header"){
				return `<h2>${item.data}</h2>`;
			} else if(item.type==="text"){
				return `<p>${item.data}</p>`;
			}
		}).join("");

		this._rpoints.back_label.innerHTML=data.back_label||"";
	}
}

export default Popup;
